module.exports = __webpack_public_path__ + "media/images/official/top_about2-4fb5d33f7b784753be74a38710ca9d96.svg";